import React , { useContext } from "react"
import { Link } from "gatsby"
import ArticleCard from "../ArticleCard/ArticleCard";
import phonesmartsupport from './../../images/stickers_phonesmartsupport.png';
import "./RelatedArticles.scss";

import { ChildAPIContext } from '../../utils/childapi'
import { UserContext } from "../../utils/usermanagement"

function ArticlesList({articles, engagement}) {
	const articleItems = articles.map((article, index) =>
	  	<div className="col-12 col-lg-4" key={index}>
			<ArticleCard article={article} engagement={engagement}/>
		</div>
	);

	return articleItems;
}


const RelatedArticles = ({title, articles, engagement}) => {
	const childAPIData = useContext(ChildAPIContext)
	const userStateData = useContext(UserContext)

	if(articles && articles.length) {
		let rollType="anonymous"
		let loginStatus="logged-out"

		if(childAPIData?.childAPI && childAPIData?.childAPI[0]?.auth_token) {
			rollType="kids"
			loginStatus="logged-in"
		} else if(userStateData && userStateData[0] && userStateData[0]?.cognito_user?.username) {
			rollType="parent"
			loginStatus="logged-in"
		}

		return (
			<section className="related-articles">
				<img src={phonesmartsupport} alt="stickers phonesmart support" className="artical-icon" />
				<div className="container">
					<div className="related-articles-wrapper"> 
						<h2>{title}</h2>
						
						<div className="row">
							<ArticlesList articles={articles} engagement={engagement} />
						</div>
						<div className="text-end">
							<Link to={`/online-safety-tips/`} className="link link-primary" 
							data-analytics={`{
								"event" : "see_all_article",
								"loginStatus" : "${loginStatus}",
								"actionType" : "Link Click",
								"clickText" : "See all articles",
								"linkType" : "internal",
								"linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/online-safety-tips/",
								"moduleName" : "${engagement} - Engagement",
								"pageName" : "${engagement}",
								"userType" : "${rollType}"
							  }`}> <span>&gt;</span> See all articles</Link>
						</div>
					</div>
				</div>
			</section>
		)
	}

	return <></>
}

export default RelatedArticles;
